import React from 'react'

const SvgPregnant = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M10.651 7.98c1.657 0 3-1.338 3-2.99a2.995 2.995 0 00-3-2.99c-1.656 0-3 1.339-3 2.99a2.995 2.995 0 003 2.99zM10.5 8.977c2.029.006 3.5 1.495 3.5 3.828 0 0 4 .23 4 4.645 0 5.497-6.802 5.116-9.686 3.489 0 0 2.686 0 2.686-2.3v-4.18s0-.498-.5-.498c-.477 0-.499.453-.5.495v.007l-.03 4.176s0 1.303-1.47 1.303c-1.5 0-1.5-1.303-1.5-1.303v-5.675c0-2.99 1.424-3.992 3.5-3.987z' />
  </svg>
)

export default SvgPregnant
